import { SHOP_ACTION, COMMON_CONTENT_ACTION, SHOP_ACTION_LOADER, HOME_ACTION } from "../type"
 
const initialState ={
    loader : false,
    data :{},
    common_data :{}
}
 
const listingReducer  = (state = initialState, action) => {
    switch (action.type){
        case SHOP_ACTION_LOADER:{
            return {...state,loader : action.loader};
        }
        case SHOP_ACTION :{
            return {...state, data: action.data};
        }
        case COMMON_CONTENT_ACTION :{
             return {...state, common_data: action.data};
        }
        default :{
            return state
        }
    }
}
 
export default listingReducer;